import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTServiceCategoriesStatePage from './BOTServiceCategoriesStatePage'

export default compose(
  withType({ type: 'BOTServiceCategoriesStatePage' })
)(BOTServiceCategoriesStatePage)
